import { getCurrentEnvironment } from '@pb/services';
import { TFeatures } from './features.type';

export function getFeatures(): TFeatures {
    const environment = getCurrentEnvironment();

    switch (environment) {
        case 'development':
            return {
                projectHugoEnabled: true,
                sourceOfFundsUploadEnabled: true,
            };
        case 'qa':
            return {
                projectHugoEnabled: true,
                sourceOfFundsUploadEnabled: true,
            };
        case 'production':
            return {
                projectHugoEnabled: true,
                sourceOfFundsUploadEnabled: true,
            };
    }
}
